import { cva } from '@/styled-system/css';

export const labelRecipe = cva({
  base: {
    color: {
      base: 'Label.text.default',
      _hover: 'Label.text.hover',
    },
    _notDisabled: {
      cursor: 'pointer',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
    required: {
      true: {
        _after: {
          content: '"*" / ""',
          color: 'Label.indicator.required',
          marginInlineStart: 'FormField.labelArea.gap.label-toRequired',
        },
      },
      false: {},
    },
    optional: {
      true: {
        _after: {
          content: '"(optional)"',
          color: 'Label.indicator.optional',
          fontWeight: '{normal}',
          marginInlineStart: 'FormField.labelArea.gap.label-toOptional',
        },
      },
      false: {},
    },
    size: {
      md: {
        textStyle: 'body-sm-bold',
      },
      lg: {
        textStyle: 'body-bold',
      },
    },
  },
});
